var _path, _path2, _path3, _rect, _path4, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.332 30.3815L17.5543 23.7148L24.7765 30.3815",
    stroke: "url(#paint0_linear_646_10933)",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2218 5.9375H4.77734V22.8264C4.77734 23.931 5.67277 24.8264 6.77734 24.8264H27.2218C28.3264 24.8264 29.2218 23.931 29.2218 22.8264V5.9375Z",
    fill: "url(#paint1_linear_646_10933)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 4.82617L30.3327 4.82617",
    stroke: "#D96700",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.11133,
    y: 9.27051,
    width: 17.7778,
    height: 12.2222,
    fill: "white",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5547 18.1596L15.3699 15.4133L17.5861 17.5797L22.5547 12.604",
    stroke: "#FFFCF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_646_10933",
    x1: 17.5543,
    y1: 23.7148,
    x2: 17.5543,
    y2: 30.3815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D06300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA350"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_646_10933",
    x1: 16.9996,
    y1: 5.9375,
    x2: 16.9996,
    y2: 24.8264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7B32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDAA64"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default "https://cdn.d2cgo.com/dtc_center/v19/so_assets/static/media/reporting.d3aee2e602ea863d7ee8d1f4e4fbd7a4.svg";
export { ForwardRef as ReactComponent };